import { IUpdateLeadDataDto } from "services/caju/salesForce/iUpdateLeadDataDto";
import { IStep2FormValues } from "../useStep2Form/iStep2FormValues";

export function getDtoFromStep2FormValues(
  leadId: string,
  values: IStep2FormValues
) {
  const result: IUpdateLeadDataDto = {
    ExternalId__c: leadId,

    company: values.company,
    employees_number__c: values.employeesNumber,
    where_met_caju__c: values.whereMeetCaju,

    PostalCode: values.cep,
    company_linkedin__c: values.linkedin,
    Website: values.website,
    State: values.uf,
  };

  return result;
}
